import { CFBaseStepperTokens } from './';
import { CFTokens } from '../../../tokens';
export const buttonPadding = ({ location, }) => {
    const paddingLeft = location === 'left' ? CFTokens.SPACER.C : 0;
    const paddingRight = location === 'left' ? 0 : CFTokens.SPACER.C;
    return `0 ${paddingRight}px 0 ${paddingLeft}px`;
};
export const fontSize = ({ size = 'md' }) => {
    return CFBaseStepperTokens.FONT_SIZE[size];
};
export const rootHeight = ({ size = 'md' }) => {
    return CFBaseStepperTokens.ROOT_HEIGHT[size];
};
export const focusedWebBackground = ({ focused }) => {
    return focused ? CFBaseStepperTokens.ROOT_BACKGROUND.FOCUSED : '';
};
export const focusedMobileBackground = ({ focused, }) => {
    return focused ? CFBaseStepperTokens.ROOT_BACKGROUND.FOCUSED : 'transparent';
};
export const focusedBorder = ({ focused }) => {
    return focused
        ? CFBaseStepperTokens.ROOT_BORDER_COLOR.FOCUSED
        : CFBaseStepperTokens.ROOT_BORDER_COLOR.DEFAULT;
};
